import { Ingredients } from '@/services/ingredients'

const loadAll = (context) => {
  (new Ingredients(true)).fetch().then(
    res => context.commit('SET_INGREDIENTS', res.data)
  ).catch(
    e => console.error(e)
  )
}

const load = (context, ingredientId) => {
  (new Ingredients(true)).fetch(ingredientId).then(
    res => context.commit('SET_INGREDIENT', res.data)
  ).catch(
    e => console.error(e)
  )
}

const save = (context, params) => {
  (new Ingredients(true)).save(params).then(
    res => params.id ? context.commit('UPDATE', params) : context.commit('PUSH', res.data)
  ).catch(
    e => console.error(e)
  )
}

const remove = (context, unitId) => {
  (new Ingredients(true)).destroy(unitId).then(
    () => context.commit('REMOVE', unitId)
  ).catch(
    e => console.error(e)
  )
}

export default {
  save,
  load,
  remove,
  loadAll
}
